import { gql } from '@apollo/client'

export const chatHandleVideo = gql`
  query ChatHandleVideo($prompt: String!, $conversation: String!) {
    chatHandleVideo(prompt: $prompt, conversation: $conversation) {
      _id
      content
      prompt
      type
      conversation
      status
      template
      alt
      metadata
      createdAt
      ref
    }
  }
`
